module.exports = __webpack_public_path__ + "img/picture_30.a4fbda57.png";